import { AspectMap } from "./aspects";
import { Or0, Principles } from "./principles";

export interface SchoolMap {
  // Whether it is committed or not
  "wisdom.committed"?: number;

  // Schools
  "w.illumination"?: number;
  "w.ithastry"?: number;
  "w.preservation"?: number;
  "w.horomachistry"?: number;
  "w.hushery"?: number;
  "w.bosk"?: number;
  "w.nyctodromy"?: number;
  "w.birdsong"?: number;
  "w.skolekosophy"?: number;
}

export interface Skill extends AspectMap, SchoolMap {
  id: string;
  label: string;
  color?: string;

  // Whether it has been used to evolve souls already.
  "a.xhausted"?: number;
}

export function commited(skill: Skill) {
  return skill["wisdom.committed"];
}

export function GetSkillById(id: string, level = 1): Skill {
  const skill = { ...Skills.find((s) => s.id === id) } as Skill;
  if (!skill) throw new Error(`Couldn't find skill with id: ${id}`);
  return EvolveSkill(skill, level);
}

export function EvolveSkill(skill: Skill, level = 1): Skill {
  skill = { ...skill };
  if (level == 0) skill.skill = 0;
  if (level <= 1) return skill;
  for (const principle of Principles) {
    if (skill[principle]) skill[principle] += 1;
  }

  skill.skill = Or0(skill.skill) + 1;

  return EvolveSkill(skill, level - 1);
}

export function GetSkillByEffectiveAgainstId(
  curedById: string,
  skills = Skills,
): Skill[] {
  return skills.filter((s) => (s as any)[curedById]);
}

export const Skills: Skill[] = [
  {
    id: "s.preliminalmeter",
    knock: 2,
    rose: 1,
    "w.illumination": 1,
    "w.ithastry": 1,
    skill: 1,
    label: "Preliminal Meter",
    "s.preliminalmeter": 1,
  },
  {
    id: "s.pyroglyphics",
    forge: 2,
    lantern: 1,
    "w.illumination": 1,
    "w.ithastry": 1,
    "skill.chandlery": 1,
    skill: 1,
    label: "Pyroglyphics",
    "s.pyroglyphics": 1,
  },
  {
    id: "s.inks.containment",
    winter: 2,
    moon: 1,
    "w.preservation": 1,
    "w.horomachistry": 1,
    "effective.contamination.theoplasma": 1,
    skill: 1,
    label: "Inks of Containment",
    "s.inks.containment": 1,
  },
  {
    id: "s.inks.revelation",
    lantern: 2,
    moth: 1,
    "w.hushery": 1,
    "w.ithastry": 1,
    skill: 1,
    label: "Inks of Revelation",
    "s.inks.revelation": 1,
  },
  {
    id: "s.inks.power",
    rose: 2,
    scale: 1,
    "w.hushery": 1,
    "w.horomachistry": 1,
    skill: 1,
    label: "Inks of Power",
    "s.inks.power": 1,
  },
  {
    id: "s.drums.dances",
    heart: 2,
    nectar: 1,
    "w.bosk": 1,
    "w.horomachistry": 1,
    skill: 1,
    label: "Drums & Dances",
    "s.drums.dances": 1,
  },
  {
    id: "s.strings.songs",
    sky: 2,
    heart: 1,
    "w.nyctodromy": 1,
    "w.birdsong": 1,
    skill: 1,
    label: "Strings & Songs",
    "s.strings.songs": 1,
  },
  {
    id: "s.bells.brazieries",
    forge: 2,
    sky: 1,
    "w.horomachistry": 1,
    "w.ithastry": 1,
    skill: 1,
    label: "Bells & Brazieries",
    "s.bells.brazieries": 1,
  },
  {
    id: "s.horns.ivories",
    scale: 2,
    knock: 1,
    "w.skolekosophy": 1,
    "w.bosk": 1,
    skill: 1,
    label: "Horns & Ivories",
    "s.horns.ivories": 1,
  },
  {
    id: "s.surgeries.exsanguinations",
    heart: 2,
    knock: 1,
    "w.hushery": 1,
    "w.preservation": 1,
    "effective.contamination.infestation": 1,
    skill: 1,
    label: "Surgeries & Exsanguinations",
    "s.surgeries.exsanguinations": 1,
  },
  {
    id: "s.stitching.binding",
    sky: 2,
    heart: 1,
    "w.ithastry": 1,
    "w.preservation": 1,
    "effective.contamination.infestation": 1,
    skill: 1,
    label: "Stitching & Binding",
    "s.stitching.binding": 1,
  },
  {
    id: "s.furs.feathers",
    sky: 2,
    scale: 1,
    "w.nyctodromy": 1,
    "w.bosk": 1,
    skill: 1,
    label: "Furs & Feathers",
    "s.furs.feathers": 1,
  },
  {
    id: "s.pearl.tide",
    rose: 2,
    moon: 1,
    "w.nyctodromy": 1,
    "w.bosk": 1,
    skill: 1,
    label: "Pearl & Tide",
    "s.pearl.tide": 1,
  },
  {
    id: "s.insects.nectars",
    nectar: 2,
    moon: 1,
    "w.nyctodromy": 1,
    "w.bosk": 1,
    "skill.chandlery": 1,
    skill: 1,
    label: "Insects & Nectars",
    "s.insects.nectars": 1,
  },
  {
    id: "s.herbs.infusions",
    heart: 2,
    nectar: 1,
    "w.preservation": 1,
    "w.bosk": 1,
    "effective.contamination.corruption": 1,
    skill: 1,
    label: "Herbs & Infusions",
    "s.herbs.infusions": 1,
  },
  {
    id: "s.spices.savours",
    nectar: 2,
    forge: 1,
    "w.ithastry": 1,
    "w.bosk": 1,
    skill: 1,
    spicing: 1,
    label: "Spices & Savours",
    "s.spices.savours": 1,
  },
  {
    id: "s.leaves.thorns",
    nectar: 2,
    grail: 1,
    "w.birdsong": 1,
    "w.bosk": 1,
    skill: 1,
    label: "Leaves & Thorns",
    "s.leaves.thorns": 1,
  },
  {
    id: "s.orchids.narcotics",
    grail: 2,
    nectar: 1,
    "w.bosk": 1,
    "w.skolekosophy": 1,
    skill: 1,
    label: "Orchids & Narcotics",
    "s.orchids.narcotics": 1,
  },
  {
    id: "s.serpents.venoms",
    scale: 2,
    moon: 1,
    "w.hushery": 1,
    "w.skolekosophy": 1,
    "host.technique.summon.echidna": 1,
    skill: 1,
    label: "Serpents & Venoms",
    "s.serpents.venoms": 1,
  },
  {
    id: "s.sights.sensations",
    sky: 2,
    winter: 1,
    "w.hushery": 1,
    "w.nyctodromy": 1,
    skill: 1,
    label: "Sights & Sensations",
    "s.sights.sensations": 1,
  },
  {
    id: "s.desires.dissolutions",
    grail: 2,
    moon: 1,
    "w.bosk": 1,
    "w.horomachistry": 1,
    skill: 1,
    label: "Desires & Dissolutions",
    "s.desires.dissolutions": 1,
  },
  {
    id: "s.resurgences.emergences",
    moth: 2,
    grail: 1,
    "w.bosk": 1,
    "w.preservation": 1,
    "effective.contamination.infestation": 1,
    skill: 1,
    label: "Resurgences & Emergences",
    "s.resurgences.emergences": 1,
  },
  {
    id: "s.rhyme.remembrance",
    winter: 2,
    moon: 1,
    "w.skolekosophy": 1,
    "w.birdsong": 1,
    skill: 1,
    label: "Rhyme & Remembrance",
    "s.rhyme.remembrance": 1,
  },
  {
    id: "s.disciplines.thehammer",
    edge: 2,
    forge: 1,
    "w.illumination": 1,
    "w.nyctodromy": 1,
    skill: 1,
    label: "Disciplines of the Hammer",
    "s.disciplines.thehammer": 1,
  },
  {
    id: "s.disciplines.thescar",
    edge: 2,
    lantern: 1,
    "w.illumination": 1,
    "w.hushery": 1,
    skill: 1,
    label: "Disciplines of the Scar",
    "s.disciplines.thescar": 1,
  },
  {
    id: "s.auroralcontemplations",
    lantern: 2,
    edge: 1,
    "w.illumination": 1,
    "w.nyctodromy": 1,
    skill: 1,
    label: "Auroral Contemplations",
    "s.auroralcontemplations": 1,
  },
  {
    id: "s.applebrighteuphonies",
    sky: 2,
    grail: 1,
    "w.illumination": 1,
    "w.bosk": 1,
    skill: 1,
    label: "Applebright Euphonies",
    "s.applebrighteuphonies": 1,
  },
  {
    id: "s.watchmansparadoxes",
    lantern: 2,
    sky: 1,
    "w.illumination": 1,
    "w.nyctodromy": 1,
    skill: 1,
    label: "Watchman's Paradoxes",
    "s.watchmansparadoxes": 1,
  },
  {
    id: "s.raggedcrossroads",
    edge: 2,
    winter: 1,
    "w.illumination": 1,
    "w.skolekosophy": 1,
    skill: 1,
    label: "Ragged Crossroads",
    "s.raggedcrossroads": 1,
  },
  {
    id: "s.meniscatereflections",
    forge: 2,
    edge: 1,
    "w.illumination": 1,
    "w.preservation": 1,
    "effective.contamination.theoplasma": 1,
    skill: 1,
    label: "Meniscate Reflections",
    "s.meniscatereflections": 1,
  },
  {
    id: "s.putrefactions.calcinations",
    winter: 2,
    moon: 1,
    "w.ithastry": 1,
    "w.skolekosophy": 1,
    skill: 1,
    label: "Putrefactions & Calcinations",
    "s.putrefactions.calcinations": 1,
  },
  {
    id: "s.solutions.separations",
    moth: 2,
    knock: 1,
    "w.ithastry": 1,
    "w.skolekosophy": 1,
    skill: 1,
    label: "Solutions & Separations",
    "s.solutions.separations": 1,
  },
  {
    id: "s.path.pilgrim",
    rose: 2,
    scale: 1,
    "w.birdsong": 1,
    "w.nyctodromy": 1,
    skill: 1,
    label: "Path & Pilgrim",
    "s.path.pilgrim": 1,
  },
  {
    id: "s.purifications.exaltations",
    sky: 2,
    lantern: 1,
    "w.illumination": 1,
    "w.ithastry": 1,
    "effective.contamination.corruption": 1,
    skill: 1,
    label: "Purifications & Exaltations",
    "s.purifications.exaltations": 1,
  },
  {
    id: "s.transformations.liberations",
    forge: 2,
    moth: 1,
    "w.illumination": 1,
    "w.ithastry": 1,
    "skill.chandlery": 1,
    skill: 1,
    label: "Transformations & Liberations",
    "s.transformations.liberations": 1,
  },
  {
    id: "s.lockworks.clockworks",
    knock: 2,
    sky: 1,
    "w.skolekosophy": 1,
    "w.ithastry": 1,
    skill: 1,
    label: "Lockworks & Clockworks",
    "s.lockworks.clockworks": 1,
  },
  {
    id: "s.seastories",
    moon: 2,
    grail: 1,
    "w.birdsong": 1,
    "w.nyctodromy": 1,
    skill: 1,
    label: "Sea Stories",
    "s.seastories": 1,
  },
  {
    id: "s.wolfstories",
    moon: 2,
    scale: 1,
    "w.skolekosophy": 1,
    "w.birdsong": 1,
    "host.technique.summon.echidna": 1,
    skill: 1,
    label: "Wolf Stories",
    "s.wolfstories": 1,
  },
  {
    id: "s.sandstories",
    rose: 2,
    moon: 1,
    "w.skolekosophy": 1,
    "w.birdsong": 1,
    skill: 1,
    label: "Sand Stories",
    "s.sandstories": 1,
  },
  {
    id: "s.skystories",
    sky: 2,
    rose: 1,
    "w.horomachistry": 1,
    "w.birdsong": 1,
    skill: 1,
    label: "Sky Stories",
    "s.skystories": 1,
  },
  {
    id: "s.snowstories",
    winter: 2,
    moon: 1,
    "w.hushery": 1,
    "w.birdsong": 1,
    skill: 1,
    label: "Snow Stories",
    "s.snowstories": 1,
  },
  {
    id: "s.stonestories",
    scale: 2,
    nectar: 1,
    "w.preservation": 1,
    "w.birdsong": 1,
    "effective.contamination.infestation": 1,
    skill: 1,
    label: "Stone Stories",
    "s.stonestories": 1,
  },
  {
    id: "s.vak",
    knock: 2,
    rose: 1,
    "w.nyctodromy": 1,
    "w.birdsong": 1,
    "skill.language": 1,
    skill: 1,
    label: "Vak",
    "s.vak": 1,
  },
  {
    id: "s.mandaic",
    AlphaLabelOverride: "Mandaic",
    forge: 2,
    lantern: 1,
    "w.horomachistry": 1,
    "w.ithastry": 1,
    "skill.language": 1,
    skill: 1,
    label: "Deep Mandaic",
    "s.mandaic": 1,
  },
  {
    id: "s.killasimi",
    winter: 2,
    moon: 1,
    "w.skolekosophy": 1,
    "w.bosk": 1,
    "skill.language": 1,
    skill: 1,
    label: "Killasimi",
    "s.killasimi": 1,
  },
  {
    id: "s.fucine",
    heart: 2,
    knock: 1,
    "w.hushery": 1,
    "w.ithastry": 1,
    "skill.language": 1,
    skill: 1,
    label: "Fucine",
    "s.fucine": 1,
  },
  {
    id: "s.sabazine",
    moth: 2,
    lantern: 1,
    "w.birdsong": 1,
    "w.horomachistry": 1,
    "skill.language": 1,
    skill: 1,
    label: "Sabazine",
    "s.sabazine": 1,
  },
  {
    id: "s.cracktrack",
    nectar: 2,
    scale: 1,
    "w.illumination": 1,
    "w.preservation": 1,
    "skill.language": 1,
    skill: 1,
    label: "Cracktrack",
    "s.cracktrack": 1,
  },
  {
    id: "s.hyksos",
    grail: 2,
    edge: 1,
    "w.nyctodromy": 1,
    "w.skolekosophy": 1,
    "skill.language": 1,
    skill: 1,
    label: "Hyksos",
    "s.hyksos": 1,
  },
  {
    id: "s.ericapaean",
    lantern: 2,
    winter: 1,
    "w.illumination": 1,
    "w.hushery": 1,
    "skill.language": 1,
    skill: 1,
    label: "Ericapaean",
    "s.ericapaean": 1,
  },
  {
    id: "s.ramsund",
    moth: 2,
    sky: 1,
    "w.preservation": 1,
    "w.birdsong": 1,
    "skill.language": 1,
    skill: 1,
    label: "Ramsund",
    "s.ramsund": 1,
  },
  {
    id: "s.sacrasolisinvicti",
    lantern: 2,
    sky: 1,
    "w.illumination": 1,
    "w.horomachistry": 1,
    "effective.contamination.curse": 1,
    skill: 1,
    label: "Sacra Solis Invicti",
    "s.sacrasolisinvicti": 1,
  },
  {
    id: "s.tridesmahiera",
    moon: 2,
    grail: 1,
    "w.bosk": 1,
    "w.preservation": 1,
    "effective.contamination.curse": 1,
    skill: 1,
    label: "Tridesma Hiera",
    "s.tridesmahiera": 1,
  },
  {
    id: "s.sacralimiae",
    moth: 2,
    sky: 1,
    "w.horomachistry": 1,
    "w.hushery": 1,
    "effective.contamination.curse": 1,
    skill: 1,
    label: "Sacra Limiae",
    "s.sacralimiae": 1,
  },
  {
    id: "s.sickle.eclipse",
    edge: 2,
    moon: 1,
    "w.nyctodromy": 1,
    "w.preservation": 1,
    "effective.contamination.corruption": 1,
    skill: 1,
    label: "Sickle & Eclipse",
    "s.sickle.eclipse": 1,
  },
  {
    id: "s.hill.hollow",
    moon: 2,
    scale: 1,
    "w.preservation": 1,
    "w.birdsong": 1,
    "effective.contamination.infestation": 1,
    skill: 1,
    label: "Hill & Hollow",
    "s.hill.hollow": 1,
  },
  {
    id: "s.pentiments.precursors",
    scale: 2,
    grail: 1,
    "w.skolekosophy": 1,
    "w.birdsong": 1,
    "host.technique.summon.echidna": 1,
    skill: 1,
    label: "Pentiments & Precursors",
    "s.pentiments.precursors": 1,
  },
  {
    id: "s.coil.chasm",
    scale: 2,
    nectar: 1,
    "w.nyctodromy": 1,
    "w.skolekosophy": 1,
    "host.technique.summon.echidna": 1,
    skill: 1,
    label: "Coil & Chasm",
    "s.coil.chasm": 1,
  },
  {
    id: "s.rites.theroots",
    nectar: 2,
    moth: 1,
    "w.bosk": 1,
    "w.preservation": 1,
    skill: 1,
    label: "Rites of the Roots",
    "s.rites.theroots": 1,
  },
  {
    id: "s.door.wall",
    knock: 2,
    forge: 1,
    "w.nyctodromy": 1,
    "w.horomachistry": 1,
    skill: 1,
    label: "Door & Wall",
    "s.door.wall": 1,
  },
  {
    id: "s.edictsliminal",
    moth: 2,
    knock: 1,
    "w.nyctodromy": 1,
    "w.skolekosophy": 1,
    skill: 1,
    label: "Edicts Liminal",
    "s.edictsliminal": 1,
  },
  {
    id: "s.edictsmartial",
    moon: 2,
    edge: 1,
    "w.illumination": 1,
    "w.horomachistry": 1,
    skill: 1,
    label: "Edicts Martial",
    "s.edictsmartial": 1,
  },
  {
    id: "s.edictsinviolable",
    heart: 2,
    moon: 1,
    "w.horomachistry": 1,
    "w.preservation": 1,
    skill: 1,
    label: "Edicts Inviolable",
    "s.edictsinviolable": 1,
  },
  {
    id: "s.thegreatsignsandthegreatscars",
    AlphaLabelOverride: "Great Signs and the Great Scars",
    grail: 2,
    knock: 1,
    "w.hushery": 1,
    "w.horomachistry": 1,
    skill: 1,
    label: "The Great Signs and the Great Scars",
    "s.thegreatsignsandthegreatscars": 1,
  },
  {
    id: "s.maggephenemysteries",
    moon: 2,
    heart: 1,
    "w.hushery": 1,
    "w.preservation": 1,
    "effective.contamination.corruption": 1,
    skill: 1,
    label: "Maggephene Mysteries",
    "s.maggephenemysteries": 1,
  },
  {
    id: "s.weaving.knotworking",
    heart: 2,
    moth: 1,
    "w.bosk": 1,
    "w.birdsong": 1,
    skill: 1,
    label: "Weaving & Knotworking",
    "s.weaving.knotworking": 1,
  },
  {
    id: "s.anbary.lapidary",
    sky: 2,
    forge: 1,
    "w.horomachistry": 1,
    "w.ithastry": 1,
    skill: 1,
    label: "Anbary & Lapidary",
    "s.anbary.lapidary": 1,
  },
  {
    id: "s.quenchings.quellings",
    winter: 2,
    heart: 1,
    "w.preservation": 1,
    "w.hushery": 1,
    "effective.contamination.theoplasma": 1,
    skill: 1,
    label: "Quenchings & Quellings",
    "s.quenchings.quellings": 1,
  },
  {
    id: "s.glassblowing.vesselcrafting",
    knock: 2,
    sky: 1,
    "w.ithastry": 1,
    "w.hushery": 1,
    skill: 1,
    label: "Glassblowing & Vesselcrafting",
    "s.glassblowing.vesselcrafting": 1,
  },
  {
    id: "s.glaziery.lightsmithing",
    lantern: 2,
    sky: 1,
    "w.illumination": 1,
    "w.ithastry": 1,
    "skill.chandlery": 1,
    skill: 1,
    label: "Glaziery & Lightsmithing",
    "s.glaziery.lightsmithing": 1,
  },
  {
    id: "s.sharps",
    edge: 2,
    moon: 1,
    "w.skolekosophy": 1,
    "w.hushery": 1,
    skill: 1,
    label: "Sharps",
    "s.sharps": 1,
  },
  {
    id: "s.ouranoscopy",
    sky: 2,
    moon: 1,
    "w.horomachistry": 1,
    "w.hushery": 1,
    skill: 1,
    label: "Ouranoscopy",
    "s.ouranoscopy": 1,
  },
  {
    id: "s.henavek",
    scale: 2,
    forge: 1,
    "w.bosk": 1,
    "w.ithastry": 1,
    "skill.language": 1,
    skill: 1,
    label: "Henavek",
    "s.henavek": 1,
  },
] as any as Skill[];
